const callIfExists = (cb, scope, extraArgs) => {
    if (cb && typeof cb === 'function') {
        cb.bind2(scope, extraArgs)();
    }
};
export default callIfExists;
